import React from "react";
import { SvgProps } from "./Form";

export const Italic = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5 3V2H5V3H8.177L6.8135 13H3.5V14H11V13H7.823L9.1865 3H12.5Z"
      fill="currentColor"
    />
  </svg>
);
